import { render, staticRenderFns } from "./SaleTypeCalendarSettings.vue?vue&type=template&id=10b4790f&scoped=true"
import script from "./SaleTypeCalendarSettings.vue?vue&type=script&lang=ts"
export * from "./SaleTypeCalendarSettings.vue?vue&type=script&lang=ts"
import style0 from "./SaleTypeCalendarSettings.vue?vue&type=style&index=0&id=10b4790f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4790f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b4790f')) {
      api.createRecord('10b4790f', component.options)
    } else {
      api.reload('10b4790f', component.options)
    }
    module.hot.accept("./SaleTypeCalendarSettings.vue?vue&type=template&id=10b4790f&scoped=true", function () {
      api.rerender('10b4790f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/SaleTypeCalendarSettings.vue"
export default component.exports